import { Box, Button, Icon, Paper, Typography } from "@mui/material";
import React from "react";
import CustomerDetailsContext from "../context";
import DataTable from "./DataTable";
import TransactionsContext from "./context";
import RegisterComponent from "./register";
import { useTransactionsManager } from "./useTransactions";

const CustomerTransactions = () => {
  return (
    <Paper sx={{ p: 2 }} elevation={3}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5">Registros de pontuação</Typography>

        <RegisterComponent>
          {({ handleClickOpen }) => (
            <Button
              variant="contained"
              startIcon={<Icon>add</Icon>}
              onClick={handleClickOpen}
            >
              Registrar
            </Button>
          )}
        </RegisterComponent>
      </Box>
      <DataTable />
    </Paper>
  );
};

const Index = () => {
  const { customer } = React.useContext(CustomerDetailsContext);

  return (
    <TransactionsContext.Provider value={useTransactionsManager(customer)}>
      <CustomerTransactions />
    </TransactionsContext.Provider>
  );
};

export default React.memo(Index);
